import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import styles from './IconButton.module.css';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required: every icon-only control must expose an accessible label. */
  'aria-label': string;
  children: ReactNode;
}

/** Minimal square ghost button used for header utility actions. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton({ className, children, type = 'button', ...rest }, ref) {
    return (
      <button
        ref={ref}
        type={type}
        className={[styles.iconButton, className].filter(Boolean).join(' ')}
        {...rest}
      >
        {children}
      </button>
    );
  },
);
